import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NetworkStatusService } from '../services/networkstatus.service';
import { AlertService } from '../services/alert.service';
import { StatePersistService } from '../services/state-persist.service';


@Injectable({ providedIn: 'root' })
export class OfflineInterceptor implements HttpInterceptor {
  constructor(private networkStatusService: NetworkStatusService, private alertService: AlertService,
    private stateService: StatePersistService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.networkStatusService.isOnline) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          // Handle error here (e.g., show a user-friendly error message)
          return throwError(error);
        })
      );
    } else {
      // If offline, reject the request
      this.alertService.error('You are offline! Please check your internet connection.');
      this.stateService.emitSelectedStore('update selected store')
      return throwError({ status: 0, message: 'No internet connection' });
    }
  }
}

